import {
  Fieldset as ChakraFieldset,
  FieldsetLegendProps,
} from '@chakra-ui/react'

export const FieldSetRoot = ChakraFieldset.Root
export const FieldSetLegend = ({
  fontWeight = 'semibold',
  fontSize = 'md',
  color = 'gray.600',
  children,
  ...props
}: FieldsetLegendProps) => {
  return (
    <ChakraFieldset.Legend
      fontWeight={fontWeight}
      color={color}
      fontSize={fontSize}
      {...props}
    >
      {children}
    </ChakraFieldset.Legend>
  )
}
export const FieldSetContent = ChakraFieldset.Content
export const FieldSetErrorText = ChakraFieldset.ErrorText
export const FieldSetHelperText = ChakraFieldset.HelperText
